import dayjs from 'dayjs';

export const microdataServiceConstructor = (
  id,
  name,
  brandName,
  images,
  url,
  currency,
  price,
  availability
) => {
  const availabilityChecker = (availability) => {
    switch (availability) {
      case 'Немає в наявності':
        return 'https://schema.org/OutOfStock';
      case 'Під замовлення':
        return 'https://schema.org/BackOrder';
      default:
        return 'https://schema.org/InStock';
    }
  };
  const priceValidUntil = dayjs().add(1, 'year').format('YYYY-MM-DD');
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: name,
    image: images.length !== 0 ? images : [],
    sku: id,
    brand: {
      '@type': 'Brand',
      name: brandName
    },
    offers: {
      '@type': 'Offer',
      url: url,
      priceCurrency: currency,
      price: price,
      priceValidUntil: priceValidUntil,
      itemCondition: 'https://schema.org/NewCondition',
      availability: availabilityChecker(availability)
    }
  };
  return data;
};
